export default __webpack_public_path__ + "static/media/event-modal-header-mesh.549d6f82.png";